module.exports = __webpack_public_path__ + "static/media/instragam.1140f227.svg";